let _ = require("ES/lib/lodash");
let esUtils = require("ES/utils/esUtils");
let dateformat = require("ES/lib/dateformat");
let AuthedUserSession = require("./AuthedUserSession");

let TIMEZONE_DATA = require("./timezone_data.json");

let EVENT_STATUSES = {
  //TODO keep in sync with class.Event.php
  held: 0,
  confirmed: 1,
  canceled: 9,
  lead: 10,
  zimbra: 11,
  postponed: 12,
  closed: 13,
};

let CONTACT_PRIMARY = 1;
let CONTACT_CSP = 2;
let CONTACT_HOLDS = 4;
let CONTACT_ONLINEOFFICEACCESS = 8;

let EVENTTYPE_PD = 3;

let ST_USERTYPE_SUPER_ADMIN = 3; //see class.genericUser.php const USER_TYPE_SUPER_ADMIN
let ST_USERTYPE_STAFF = 1;
let ST_USERTYPE_SPEAKER = 2;

let file_type_icon_map = {
  pdf: "fa-file-pdf-o",
  ps: "fa-file-pdf-o",

  txt: "fa-file-text-o",

  doc: "fa-file-word-o",
  docx: "fa-file-word-o",
  odt: "fa-file-word-o",
  rtf: "fa-file-word-o",
  eml: "fa-envelope-o",

  ppt: "fa-file-powerpoint-o",
  pptx: "fa-file-powerpoint-o",
  odp: "fa-file-powerpoint-o",

  xls: "fa-file-excel-o",
  xlsx: "fa-file-excel-o",
  ods: "fa-file-excel-o",

  mp3: "fa-file-audio-o",
  wma: "fa-file-audio-o",
  wav: "fa-file-audio-o",

  png: "fa-file-image-o",
  gif: "fa-file-image-o",
  jpg: "fa-file-image-o",
  bmp: "fa-file-image-o",

  mp4: "fa-file-video-o",
  mpg: "fa-file-video-o",
  mpeg: "fa-file-video-o",
  wmv: "fa-file-video-o",
  mov: "fa-file-video-o",
  avi: "fa-file-video-o",
  vob: "fa-file-video-o",

  zip: "fa-file-archive-o",
  tgz: "fa-file-archive-o",
  tar: "fa-file-archive-o",
  rar: "fa-file-archive-o",
  "7z": "fa-file-archive-o",
};

let getFileTypeIcon = function (file_name) {
  let parts = /\.[0-9a-z]+$/i.exec(file_name);
  let extension = ((parts && parts[0]) || "").replace(/\./, "").toLowerCase();
  return file_type_icon_map[extension] || "fa-file-o";
};

let buildMailToURLForEvent = function (event, email, Displaylists) {
  if (!_.isString(email)) {
    return null;
  }
  let my_speaker_names_by_sid = _.object(
    _.map(Displaylists.perspeaker, function (speaker) {
      return [speaker.sid, speaker.name_full];
    })
  );

  let speaker_names = _.map(event.sids, function (sid) {
    return my_speaker_names_by_sid[sid];
  }).join(", ");

  let stagetime = _.first(event.Stagetime) || {};
  let venue =
    _.find(event.Venue, function (v) {
      return v.id == stagetime.venueid;
    }) || {};

  let subject = _.reject(
    [
      speaker_names,
      event.organization,
      _.isDate(stagetime.starttime)
        ? dateformat(stagetime.starttime, "mmm d, yyyy")
        : null,
      _.reject([venue.city, venue.st], esUtils.isBlank).join(", "),
    ],
    esUtils.isBlank
  ).join(" - ");

  return (
    "mailto:" +
    encodeURIComponent(email) +
    "?subject=" +
    encodeURIComponent(subject)
  );
};

module.exports = {
  EVENT_STATUSES,
  TIMEZONE_DATA,
  EVENT_STATUSES_by_num: _.object(
    _.map(_.pairs(EVENT_STATUSES), function (pair) {
      return pair.reverse();
    })
  ),
  DELIVERY_METHOD_INTEGERS: {
    ONSITE: 1,
    VIRTUAL: 2,
  },

  EVENT_STATUS_PRIORITY: {
    canceled: 0,
    closed: 1,
    postponed: 2,
    lead: 3,
    held: 4,
    confirmed: 5,
  },

  GRAB_SERVICES: {
    MAC_CONTACTS: "Mac Contacts",
    EP: "Other Events",
    HL: "HighLevel",
    SALESFORCE: "SalesForce",
    GOOGLEAPI: "Google Contacts",
    INFUSION: "Keap",
    INSIGHTLY: "Insightly",
    KARMACRM: "karmaCRM",
    HUBSPOT: "Hubspot",
    ZOHOCRM: "ZohoCRM",
  }, //    OUTLOOK: 'Outlook',    ZIMBRA: 'Zimbra',

  GRAB_SERVICES_WITH_DEEP_INTEGRATION: {
    KARMACRM: {
      browser_window_name: "KarmaCRMWindow",
    },
    HUBSPOT: {
      browser_window_name: "HubspotWindow",
    },
    ZOHOCRM: {
      browser_window_name: "ZohoCRMWindow",
    },
    HL: {
      browser_window_name: "HighLevelWindow",
    },
  }, //these crms show up on the navbar, and also link contacts directly

  GRAB_SERVICES_not_yet_supported: ["OUTLOOK"],

  HOLD_PRIORITY: {
    1: "weak",
    5: "normal",
    9: "strong",
  },

  QTYCUSTOMS: 10,
  QTYLONGCUSTOMS: 8,

  CC_INIT_VALUES: {
    //Comes from Event::$CC_INIT_VALUES
    1: "we call them",
    2: "they call us",
    3: "in person",
  },

  EVENTTYPE_PD,
  CONTACT_PRIMARY,
  CONTACT_CSP,
  CONTACT_HOLDS,
  CONTACT_ONLINEOFFICEACCESS,
  ST_USERTYPE_SPEAKER,
  ST_USERTYPE_STAFF,
  ST_USERTYPE_SUPER_ADMIN,
  CONTACT_FLAGS: (function () {
    let map = {};
    map[CONTACT_PRIMARY] = "Primary contact for this event";
    map[CONTACT_CSP] = "CSP® evaluation contact";
    map[CONTACT_HOLDS] = "Contact about hold status";
    map[CONTACT_ONLINEOFFICEACCESS] =
      "Can access this event via Online Assistant";
    return map;
  })(),
  ONLINE_ASSISTANT_OPTIONS: {
    INVITE_QUESTIONNAIRE: "complete questionnaire",
    INVITE_CONFIRM: "please release or confirm",
    MAIL_RESENDKEY: "send office key",
  },
  MAINTENANCE_IMPACT_LABELS: {
    1: "No Interruption expected",
    2: "No Downtime, but logins locked",
    3: "Brief Interruption expected",
    4: "Long Interruption expected",
    5: "Unexpected Maintenance",
  },

  PRESENTATION_CATEGORY_FLAGS: {
    ARCHIVED: 1,
  },
  file_type_icon_map,
  getFileTypeIcon,
  FileStore_UPLOAD_FILE_NAME: "store_this_file", //FileStore::UPLOAD_FILE_NAME

  buildMailToURLForEvent,
  /**
   * Used to build the href for notemail links on the notes area and the contacts tab.
   *
   * @param event
   * @param contact
   * @param Displaylists
   * @returns {string}
   */
  generateNotemailHREF(event, contact, Displaylists) {
    if (AuthedUserSession.is_privatelabel) {
      return null; //don't use notemail on privatelabels yet
    }

    let recipient =
      contact !== null && contact.hasOwnProperty("email") ? contact.email : "";

    return (
      buildMailToURLForEvent(event, recipient, Displaylists) +
      "&cc=" +
      encodeURIComponent(event.notemail_address)
    ); // + '&body=' + encodeURIComponent('\n\n(Please REPLY ALL so that our eSpeakers software will pick up your response.)');
  },

  /**
   * Generate the mailto: url for the Client Portal link
   * @param event
   * @param email
   * @param Displaylists
   * @returns {string}
   */
  generateClientPortalMailtoForEvent(event, email, Displaylists) {
    let my_speaker_names_by_sid = _.object(
      _.map(Displaylists.perspeaker, function (speaker) {
        return [speaker.sid, speaker.name_full];
      })
    );

    let speaker_names = _.map(event.sids, function (sid) {
      return my_speaker_names_by_sid[sid];
    }).join(", ");

    let stagetime = _.first(event.Stagetime) || {};
    let venue =
      _.find(event.Venue, function (v) {
        return v.id == stagetime.venueid;
      }) || {};

    let subject = _.reject(
      [
        "Client Portal access for your event",
        speaker_names,
        event.organization,
        _.isDate(stagetime.starttime)
          ? dateformat(stagetime.starttime, "mmm d, yyyy")
          : null,
        _.reject([venue.city, venue.st], esUtils.isBlank).join(", "),
      ],
      esUtils.isBlank
    ).join(" - ");

    return (
      "mailto:" +
      encodeURIComponent(email) +
      "?subject=" +
      encodeURIComponent(subject) +
      "&body=" +
      encodeURIComponent(
        "Enjoy realtime access to your critical event data at " +
          event.online_assistant_url +
          "\r\n\r\nYour email address is your access key."
      )
    );
  },
};



// WEBPACK FOOTER //
// ./src/utils/Constants.js